import PrivateImage from '../presentation/PrivateImage';
import React, {useEffect, useRef, useState} from "react";
import {Redirect, useParams} from "react-router-dom";
import UserService from "../../services/user.service";
import '../../Print.css';
import { logOut} from "../../helpers/logout";
import {Button, Divider, Grid, Toolbar} from "@material-ui/core";
import ActionButton from "../form/input/ActionButton";
import Tooltip from "@material-ui/core/Tooltip";
import Paper from "@material-ui/core/Paper";
import Container from "@material-ui/core/Container";
import {makeStyles} from "@material-ui/core/styles";
import clsx from "clsx";
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import GeneratedDocumentEmailAction from "./GeneratedDocumentEmailAction";
import {PDFExport} from '@progress/kendo-react-pdf';
import {getPdfExportProxyProps, savePdfWithEmbeddedImages} from "../../helpers/pdfExport";
import {NotificationManager} from "react-notifications";
import TextInput from "../form/input/TextInput";
import DateInput from "../form/input/DateInput";
import Time from "react-time-format";
import BorderColorIcon from '@material-ui/icons/BorderColor';
import Popup from "../presentation/Popup";
import {ReactSketchCanvas} from "react-sketch-canvas";
import {convertSize} from "../../helpers/helper";
import {exportSignatureAsSvgBlob} from "../../helpers/signature";

const useStyles = makeStyles((theme) => ({
    appBarSpacer: theme.mixins.toolbar,
    root: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
    seeMore: {
        marginTop: theme.spacing(8),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    toolbarButtons: {
        '& .MuiFormControl-root': {
            margin: theme.spacing(1)
        }
    },
    marginElement: {
        margin: theme.spacing(2)
    },
    marginTop: {
        marginTop: theme.spacing(2)
    },
    icon: {
        marginRight: theme.spacing(2),
    },
    heroContent: {
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(8, 0, 6),
    },
    heroButtons: {
        marginTop: theme.spacing(4),
    },
    cardGrid: {
        paddingTop: theme.spacing(8),
        paddingBottom: theme.spacing(8),
    },
    cardMedia: {
        height: 200,
        width: 150,
        borderRadius: 10
    },
    cardContent: {
        flexGrow: 1,
    }
}));


const FuneralRecordGenerator = (props) => {
    const classes = useStyles();
    const fixedHeightPaper = clsx(classes.paper);
    let canvas = useRef(null);
    
    const pdfRef = useRef(null);
    const [funeral, setFuneral] = useState({
        contracting_authority: '',
        ca_address: '',
        ca_zip: '',
        ca_city: '',
        ca_state: '',
        ca_nationality: '',
        ca_email: '',
        ca_phone: '',
        ca_id: '',
        ca_birth: '',
        ca_relationship: '',
        deceased: '',
        d_maiden_name: '',
        d_address: '',
        d_zip: '',
        d_city: '',
        d_state: '',
        d_place_birth: '',
        d_birth: '',
        d_gender: '',
        d_marital_status: '',
        d_death: '',
        d_place_death: '',
        d_id: '',
        d_nationality: '',
        d_education: '',
        d_last_job: '',
        d_wife_husband: '',
        d_wife_husband_id: '',
        planned_pickup_place: '',
        planned_pickup: '',
        town_funeral: '',
        place_funeral: '',
        date_funeral: '',
        coffin_arrival: '',
        coffin_arrival_place: '',
        place: {},
        signatures: {}
    });
    const [show, setShow] = useState(false);
    const [success, setSuccess] = useState(false);
    const [date, setDate] = useState(new Date());
    const [location, setLocation] = useState('');

    const [user, setUser] = useState(null);

    const funeral_id = useParams();
    const user_local = JSON.parse(localStorage.getItem('user')).id;
    const [fullScreen, setFullScreen] = useState(false);

    const handleShow = () => setShow(true);

    const handleDate = (e) => {
        setDate(e.target.value)
    }

    const handleLocation = (e) => {
        setLocation(e.target.value)
    }

    const handleClear = () => {
        const resetCanvas = canvas.current?.resetCanvas;

        if (resetCanvas) {
            resetCanvas();
        }
    }

    useEffect(() => {
        UserService.getUser(user_local).then(
            (response) => {
                setUser(response.data);
                if (response.data.defined_texts) {
                    setLocation(response.data.defined_texts.default_signature_place);
                }
            },
            (e) => {
                if (e.response.status === 401) {
                    logOut(props);
                    NotificationManager.warning('Potrebné sa znova prihlásiť!', 'Upozornenie', 5000);
                }
            }
        );
        UserService.getFuneral(funeral_id.funeral_id).then(
            (response) => {
                console.log(response.data);
                setFuneral(response.data);
            },
            (e) => {
                if (e.response.status === 401) {
                    logOut(props);
                    NotificationManager.warning('Potrebné sa znova prihlásiť!', 'Upozornenie', 5000);
                }
            }
        );
    }, [funeral_id.funeral_id, user_local, props]);

    const singleFileUploadHandler = (file) => {
            const data = new FormData();
            data.append('someimage', file, 'delegation_signature.svg');
            data.append('signatures_id', funeral.signatures._id);
            data.append('tag', 'delegation');
            data.append('date_of_delegation', new Date(date).toISOString());
            data.append('location_of_delegation', location);
            UserService.signDocument(data)
                .then((response) => {
                    if (200 === response.status) {
                        // If file size is larger than expected.
                        if (response.data.error) {
                        } else {
                            let fileName = response.data;
                            setFuneral({
                                ...funeral,
                                'signatures': {...funeral.signatures, 'delegation_signature': fileName.location}
                            });
                            setShow(false);
                        }
                    }
                }).catch((e) => {
                if (e.response.status === 401) {
                    logOut(props);
                    NotificationManager.warning('Potrebné sa znova prihlásiť!', 'Upozornenie', 5000);
                }
                NotificationManager.error('Nepodarilo sa podpísať dokument!', 'Chyba', 5000);
                setShow(false);
            });
        };
    
        const handleSignature = async () => {
            const exportSvg = canvas.current?.exportSvg;
    
            if (exportSvg) {
                try {
                    const blob = await exportSignatureAsSvgBlob(canvas);
                    singleFileUploadHandler(blob);
                } catch (e) {
                    NotificationManager.error('Nepodarilo sa podpísať dokument!', 'Chyba', 5000);
                    setShow(false);
                }
            }
        }

    const handleExport = () => {
        savePdfWithEmbeddedImages(pdfRef, (error) => {
            if (error) {
                NotificationManager.error('Nepodarilo sa exportovať PDF!', 'Chyba', 5000);
            }
        });
    }

    const showDelegation = () => {
        if (user) {
            return <div className="document-preview-frame" style={{border: '1px solid'}}>
                <PDFExport ref={pdfRef} {...getPdfExportProxyProps()} paperSize="A4" scale={0.75}
                           fileName={`potvrdenie-${funeral.contracting_authority.replace(' ', '')}`}>
                    <div className="a4-paper gendoc-doc gendoc-doc--dense">
                        {user.logo &&
                        <div className="gendoc-watermark-wrap">
                            <PrivateImage className="gendoc-watermark" src={user.logo} alt=""/>
                        </div>}
                        <div className="gendoc-body">
                            <header className="gendoc-header">
                                <div className="gendoc-header__eyebrow">{user.name}</div>
                                <h1 className="gendoc-title">Záznam o pohrebe</h1>
                                <div className="gendoc-subtitle">Informácie pre kňaza / obradníka</div>
                                <div className="gendoc-header__meta">
                                    {user.address} · IČO: {user.ico} · IČ DPH: {user.ic_dph} · Kontakt: {user.phone} · Email: {user.email_official}
                                </div>
                            </header>

                            <div className="gendoc-fill-group gendoc-cols">
                                <div className="gendoc-col">
                                    <div className="gendoc-fill"><span className="gendoc-fill__label">Matrika - Zv.:</span><span className="gendoc-fill__rule"></span></div>
                                </div>
                                <div className="gendoc-col">
                                    <div className="gendoc-fill"><span className="gendoc-fill__label">Str.:</span><span className="gendoc-fill__rule"></span></div>
                                </div>
                                <div className="gendoc-col">
                                    <div className="gendoc-fill"><span className="gendoc-fill__label">Rok:</span><span className="gendoc-fill__rule"></span></div>
                                </div>
                            </div>

                            <section className="gendoc-panel">
                                <h2 className="gendoc-section-title">Obstarávateľ pohrebu</h2>
                                <div className="gendoc-cols">
                                    <div className="gendoc-col">
                                        <p className="gendoc-line"><span className="gendoc-line__label">Titul; Meno a Priezvisko:</span> <b>{funeral.contracting_authority}</b></p>
                                        <p className="gendoc-line"><span className="gendoc-line__label">Adresa trvalého pobytu:</span> <b>{funeral.ca_address} {funeral.ca_zip} {funeral.ca_city}</b></p>
                                        <p className="gendoc-line"><span className="gendoc-line__label">Dátum narodenia:</span> <b><Time value={funeral.ca_birth} format="DD.MM.YYYY"/></b></p>
                                        <p className="gendoc-line"><span className="gendoc-line__label">Rodné číslo:</span> <b>{funeral.ca_id}</b></p>
                                    </div>
                                    <div className="gendoc-col">
                                        <p className="gendoc-line"><span className="gendoc-line__label">Príbuzenský vzťah:</span> <b>{funeral.ca_relationship}</b></p>
                                        <p className="gendoc-line"><span className="gendoc-line__label">Tel. číslo:</span> <b>{funeral.ca_phone}</b></p>
                                        <p className="gendoc-line"><span className="gendoc-line__label">Email:</span> <b>{funeral.ca_email}</b></p>
                                        <p className="gendoc-line"><span className="gendoc-line__label">Národnosť:</span> <b>{funeral.ca_nationality}</b></p>
                                    </div>
                                </div>
                                <h2 className="gendoc-section-title">Zosnulý</h2>
                                <div className="gendoc-cols">
                                    <div className="gendoc-col">
                                        <p className="gendoc-line"><span className="gendoc-line__label">Titul; Meno a Priezvisko:</span> <b>{funeral.deceased}</b></p>
                                        <p className="gendoc-line"><span className="gendoc-line__label">Adresa trvalého pobytu:</span> <b>{funeral.d_address} {funeral.d_zip} {funeral.d_city}</b></p>
                                        <p className="gendoc-line"><span className="gendoc-line__label">Národnosť:</span> <b>{funeral.d_nationality}</b></p>
                                        <p className="gendoc-line"><span className="gendoc-line__label">Rodné číslo:</span> <b>{funeral.d_id}</b></p>
                                        <p className="gendoc-line"><span className="gendoc-line__label">Dátum narodenia:</span> <b><Time value={funeral.d_birth} format="DD.MM.YYYY"/></b></p>
                                        <p className="gendoc-line"><span className="gendoc-line__label">Miesto narodenia:</span> <b>{funeral.d_place_birth}</b></p>
                                        <p className="gendoc-line"><span className="gendoc-line__label">Dátum úmrtia:</span> <b><Time value={funeral.d_death} format="DD.MM.YYYY"/></b></p>
                                        <p className="gendoc-line"><span className="gendoc-line__label">Miesto úmrtia:</span> <b>{funeral.d_place_death}</b></p>
                                    </div>
                                    <div className="gendoc-col">
                                        <p className="gendoc-line"><span className="gendoc-line__label">Rodné priezvisko:</span> <b>{funeral.d_maiden_name}</b></p>
                                        <p className="gendoc-line"><span className="gendoc-line__label">Rodinný stav:</span> <b>{funeral.d_marital_status}</b></p>
                                        <p className="gendoc-line"><span className="gendoc-line__label">Vzdelanie:</span> <b>{funeral.d_education}</b></p>
                                        <p className="gendoc-line"><span className="gendoc-line__label">Posledné zamestnanie:</span> <b>{funeral.d_last_job}</b></p>
                                        <p className="gendoc-line"><span className="gendoc-line__label">Pohlavie:</span> <b>{funeral.d_gender}</b></p>
                                        <p className="gendoc-line"><span className="gendoc-line__label">Manžel/ka:</span> <b>{funeral.d_wife_husband}</b></p>
                                        <p className="gendoc-line"><span className="gendoc-line__label">Manžel/ka rodné číslo:</span> <b>{funeral.d_wife_husband_id}</b></p>
                                    </div>
                                </div>
                            </section>

                            <section className="gendoc-section">
                                <h2 className="gendoc-section-title">Údaje o pohrebe / obrade</h2>
                                <div className="gendoc-cols">
                                    <div className="gendoc-col">
                                        <p className="gendoc-line"><span className="gendoc-line__label">Mesto/obec pohrebu:</span> <b>{funeral.town_funeral}</b></p>
                                        <p className="gendoc-line"><span className="gendoc-line__label">Kde bude pohreb:</span> <b>{funeral.place_funeral}</b></p>
                                        <p className="gendoc-line"><span className="gendoc-line__label">Kedy bude pohreb:</span> <b><Time value={funeral.date_funeral} format="DD.MM.YYYY HH:mm"/></b></p>
                                        <p className="gendoc-line"><span className="gendoc-line__label">Kremácia:</span> <b>{funeral.place && funeral.place.cremation}</b></p>
                                        <p className="gendoc-line"><span className="gendoc-line__label">Pochovaný bude na cintoríne:</span> <b>{funeral.place && funeral.place.cemetery}</b></p>
                                        <p className="gendoc-line"><span className="gendoc-line__label">Typ pohrebu:</span> <b>{funeral.funeral_type}</b></p>
                                    </div>
                                    <div className="gendoc-col">
                                        <div className="gendoc-fill"><span className="gendoc-fill__label">Omša ÁNO/NIE:</span><span className="gendoc-fill__rule"></span></div>
                                        <div className="gendoc-fill"><span className="gendoc-fill__label">Liturgia ÁNO/NIE:</span><span className="gendoc-fill__rule"></span></div>
                                    </div>
                                </div>

                                <div className="gendoc-fill"><span className="gendoc-fill__label">Rodičia (živý/zosnulý):</span><span className="gendoc-fill__rule"></span></div>
                                <div className="gendoc-fill"><span className="gendoc-fill__label">Súrodenci:</span><span className="gendoc-fill__rule"></span></div>
                                <div className="gendoc-fill"><span className="gendoc-fill__label">Deti:</span><span className="gendoc-fill__rule"></span></div>

                                <div className="gendoc-cols">
                                    <div className="gendoc-col">
                                        <div className="gendoc-fill"><span className="gendoc-fill__label">Zaopatrený/á:</span><span className="gendoc-fill__rule"></span></div>
                                        <div className="gendoc-fill"><span className="gendoc-fill__label">Príčina smrti:</span><span className="gendoc-fill__rule"></span></div>
                                        <div className="gendoc-fill"><span className="gendoc-fill__label">Rakva otvorená/zatvorená:</span><span className="gendoc-fill__rule"></span></div>
                                        <div className="gendoc-fill"><span className="gendoc-fill__label">Kňaz/obradník:</span><span className="gendoc-fill__rule"></span></div>
                                        <div className="gendoc-fill"><span className="gendoc-fill__label">Kantor/ka:</span><span className="gendoc-fill__rule"></span></div>
                                    </div>
                                    <div className="gendoc-col">
                                        <div className="gendoc-fill"><span className="gendoc-fill__label">Miništranti:</span><span className="gendoc-fill__rule"></span></div>
                                        <div className="gendoc-fill"><span className="gendoc-fill__label">Nosiči zástav:</span><span className="gendoc-fill__rule"></span></div>
                                        <div className="gendoc-fill"><span className="gendoc-fill__label">Zvonenie:</span><span className="gendoc-fill__rule"></span></div>
                                        <div className="gendoc-fill"><span className="gendoc-fill__label">Príhovor:</span><span className="gendoc-fill__rule"></span></div>
                                        <div className="gendoc-fill"><span className="gendoc-fill__label">Hudba:</span><span className="gendoc-fill__rule"></span></div>
                                    </div>
                                </div>
                            </section>

                            <div className="gendoc-sign gendoc-sign--single">
                                <div className="gendoc-sign__col gendoc-sign__col--right">
                                    <div className="gendoc-sign__meta">
                                        V {funeral.signatures.location_of_remains ? funeral.signatures.location_of_remains : location} dňa {funeral.signatures.date_of_remains ? new Date(funeral.signatures.date_of_remains).toShortFormat() : date.toShortFormat()}.
                                    </div>
                                    {funeral.signatures.delegation_signature &&
                                    <PrivateImage className="gendoc-sign__sig" src={funeral.signatures.delegation_signature} alt="Podpis"/>}
                                </div>
                            </div>
                        </div>
                    </div>
                </PDFExport>
            </div>
        }
        return <></>
    }

    return (
        <Container maxWidth="lg" className={classes.seeMore}>
            <div className={classes.root}>
                <Paper className={fixedHeightPaper}>
                    <Grid container>
                        <Grid xs={12} sm={4} md={3} lg={3} item container>
                            <Toolbar>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    hidden={true}
                                    className={classes.button}
                                    onClick={() => {
                                        setSuccess(true)
                                    }}
                                >
                                    Späť na detaily
                                </Button>
                            </Toolbar>
                        </Grid>
                        <Grid xs={12} sm={8} md={9} lg={9} item container justifyContent='flex-end'>
                            <Toolbar className={`${classes.toolbarButtons} document-actions-toolbar`}>
                                <TextInput
                                    label="Miesto podpisu"
                                    name={'location'}
                                    value={location}
                                    onChange={handleLocation}
                                />
                                <DateInput
                                    label="Dátum podpisu"
                                    name={'date'}
                                    value={date}
                                    onChange={handleDate}
                                />
                                <ActionButton
                                    color="primary">
                                    <Tooltip title="Podpísať splnomocnenie">
                                        <BorderColorIcon
                                            fontSize="small"
                                            onClick={() => {
                                                handleShow();
                                            }}
                                        />
                                    </Tooltip>
                                </ActionButton>
                                <ActionButton
                                    color="primary">
                                    <Tooltip title="Pdf export">
                                        <PictureAsPdfIcon
                                            fontSize="small"
                                            onClick={handleExport}
                                        />
                                    </Tooltip>
                                </ActionButton>
                                <GeneratedDocumentEmailAction
                                    pdfRef={pdfRef}
                                    funeral={funeral}
                                    user={user}
                                />
                            </Toolbar>
                        </Grid>
                    </Grid>

                    <Divider/>
                    <Grid className={classes.marginTop}
                          container
                          spacing={0}
                          direction="column"
                          alignItems="center"
                          justifyContent="center"
                    >
                        {showDelegation()}
                    </Grid>
                </Paper>
            </div>
            <Popup
                title={'Podpis'}
                openPopup={show}
                setOpenPopup={setShow}
                maxW = 'xl'
                actions={<>
                    <Button color="primary" variant="outlined" onClick={() => {
                        setFullScreen(!fullScreen);
                    }
                    }>
                        {fullScreen ? 'Zmenšiť' : 'Zväčšiť'}
                    </Button>
                    <Button color="primary" variant="outlined" onClick={handleClear}>
                        Vyčistiť
                    </Button>
                    <Button color="primary" variant="outlined" onClick={handleSignature}>
                        Uložiť
                    </Button>
                </>}
            >
                <ReactSketchCanvas
                    ref={canvas}
                    strokeWidth={3}
                    strokeColor="blue"
                    style={{
                        border: "0.0625rem solid #9c9c9c",
                        borderRadius: "0.25rem",
                        display: "block",
                        margin: "0 auto",
                        touchAction: "none",
                        width: fullScreen ? convertSize(props.width) : props.width === 'xs' ? "min(300px, 100%)" : "min(500px, 100%)",
                        height: fullScreen ? 'min(600px, calc(100vh - 220px))' : props.width === 'xs' ? "125px" : "300px"
                    }}
                />
            </Popup>
            {success ? <Redirect to={{
                pathname: `/pohreb/${funeral_id.funeral_id}/info`,
                state: {from: props.location, number: 5}
            }}/> : <></>}
        </Container>
    )
}
export default FuneralRecordGenerator;
